module Omni.ResortMap {
    ngModule.directive('mapPopover', [function () {
        return {
            restrict: 'EAC',
            templateUrl: 'omni/assets/resortmap/views/popover.tpl.html'
        };
    }]);
}
